<div class="main-page-wraper min-h-screen flex flex-col justify-start items-center">
    <img [src]="logo || bgUrl" class="logo" />
    <h1 *ngIf="showDoc" class="text-center text-4xl my-10">
        Ticket <span class="text-colored font-bold">{{ticket?.numeroTicket}}</span>
    </h1>

    <div class=" w-10/12">

        <div *ngIf="showDoc">

            <!-- doc data -->
            <div class="mb-5 text-lg w-full align-top ">
                <div class=" grid lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 gap-4">

                    <div class="flex flex-col w-full card bg-primary-50 h-full">
                        <h2 class="my-4 font-bold text-colored">Dati ticket</h2>

                        <p class="my-1 p-2 bg-primary-100 rounded-3xl"><b>Data creazione</b>: {{ticket?.creationDate |
                            date:'dd/MM/yyyy' }}</p>

                        <p class="my-1 p-2 bg-primary-100 rounded-3xl"
                            *ngIf="ticket && ticket.trackingTickets && ticket.trackingTickets.length > 0">
                            <b>Stato ticket</b>:
                            {{ticket.trackingTickets[ticket.trackingTickets.length - 1].stato}}
                        </p>

                        <p class="my-1 p-2 bg-primary-100 rounded-3xl"><b>Oggetto</b>:
                            {{ticket?.oggetto}}</p>

                        <p class="my-1 p-2 bg-primary-100 rounded-3xl"><b>Richiesta</b>:
                            {{ticket?.richiesta ?? '-'}}</p>

                        <p class="my-1 p-2 bg-primary-100 rounded-3xl"><b>Area Ticket</b>:
                            {{ticket?.idAreaCodice ?? '-'}}</p>

                        <p class="my-1 p-2 bg-primary-100 rounded-3xl"><b>Soluzione</b>:
                            {{ticket?.soluzione ?? '-'}}</p>
                        <p class="my-1 p-2 bg-primary-100 rounded-3xl"><b>Note cliente</b>:
                            {{ticket?.noteCliente ?? '-'}}</p>







                    </div>


                    <div class="flex flex-col w-full card bg-primary-50 h-full ">
                        <h2 class="my-4 font-bold text-colored">Avanzamento del ticket</h2>

                        <div *ngIf="ticket && ticket.trackingTickets && ticket.trackingTickets.length > 0">



                            <div *ngFor="let d of ticket.trackingTickets,let index = index">

                                <!-- Item -->
                                <div class="flex gap-x-3">
                                    <!-- Icon -->
                                    <div
                                        class="relative last:after:hidden after:absolute after:top-7 after:bottom-0 after:start-3.5 after:w-px after:-translate-x-[0.5px] after:bg-gray-200 dark:after:bg-primary-200">
                                        <div class="relative z-10 size-7 flex justify-center items-center">
                                            <div
                                                class=" m-2 p-2 rounded-full w-full flex justify-center items-center {{(index + 1) == ticket.trackingTickets.length ? 'bg-primary-500 text-white ' : 'text-colored '}}">
                                                <h3 class="font-bold"> {{index+1 }}</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- End Icon -->

                                    <!-- Right Content -->
                                    <div class="grow pt-0.5 pb-8">
                                        <div class="flex flex-row">

                                            <div class="flex flex-col">

                                                <div class="flex flex-row">
                                                    <h3 class="text-colored font-bold">{{d.stato}}</h3>
                                                </div>

                                                <div class="flex flex-row">
                                                    <p><b>Data:</b> {{d.dataCambioStato | date:'dd/MM/yyyy, HH:mm ' }}
                                                    </p>
                                                </div>

                                                <div class="flex flex-row" *ngIf="d.messaggio">
                                                    <p><b>Messaggio:</b> {{d.messaggio}}</p>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>


                            </div>
                        </div>
                        <p *ngIf="data?.length==0" class="text-lg font-bold my-5">
                            Il documento non ha alcun stato
                        </p>

                    </div>


                    <!-- steps thing like amazon -->



                </div>
                <div class="card-primary bg-white flex flex-row pb-14 px-10 " *ngIf="false">

                    <!-- the first circle with the text -->
                    <div class="flex flex-col relative">
                        <div class="bg-primary-100 w-10 h-10 p-5 flex flex-col justify-center items-center text-white  rounded-full"
                            [ngClass]="{'bg-primary-500':(idStatoDocumento >= 1 && idStatoDocumento <= 5) || idStatoDocumento == 13 || 11 }">
                            1</div>
                        <p class="absolute mt-10">Creato</p>
                    </div>

                    <!-- the line -->
                    <div class="flex flex-row items-center w-full h-10">
                        <div class="w-full p-0.5 items-center bg-primary-100"
                            [ngClass]="{'bg-primary-500':idStatoDocumento >= 2 && idStatoDocumento <= 5}">
                        </div>
                    </div>

                    <!-- the  second circle with the text -->
                    <div class="flex flex-col relative">
                        <div class="w-10 h-10 p-5 flex flex-col justify-center items-center text-white  rounded-full bg-primary-100"
                            [ngClass]="{'bg-primary-500':idStatoDocumento >= 2 && idStatoDocumento <= 5 }">
                            2</div>
                        <p class="absolute mt-10 ">Preso in consegna</p>
                    </div>

                    <!-- the line -->
                    <div class="flex flex-row items-center w-full h-10">
                        <div class="w-full p-0.5 items-center bg-primary-100"
                            [ngClass]="{'bg-primary-500':idStatoDocumento >= 3 && idStatoDocumento <= 5}">
                        </div>
                    </div>

                    <!-- the third circle with the text -->
                    <div class="flex flex-col relative">
                        <div class=" w-10 h-10 p-5 flex flex-col justify-center items-center text-white  rounded-full bg-primary-100"
                            [ngClass]="{'bg-primary-500':idStatoDocumento >= 3 && idStatoDocumento <= 5 }">
                            3</div>
                        <p *ngIf="idStatoDocumento == 4" class="absolute mt-10">Evaso parzialmente</p>
                        <p *ngIf="idStatoDocumento != 4" class="absolute mt-10">Evaso</p>
                    </div>

                    <!-- the line -->
                    <div class="flex flex-row items-center w-full h-10">
                        <div class="w-full p-0.5 items-center bg-primary-100"
                            [ngClass]="{'bg-primary-500':idStatoDocumento ==5 }"></div>
                    </div>

                    <!-- the last circle with the text -->
                    <div class="flex flex-col relative">
                        <div class="w-10 h-10 p-5 flex flex-col justify-center items-center text-white  rounded-full bg-primary-100"
                            [ngClass]="{'bg-primary-500':idStatoDocumento == 5}">4</div>
                        <p class="absolute mt-10">Chiuso</p>
                    </div>

                </div>

            </div>

        </div>





    </div>

    <div *ngIf="!showDoc && !error" class="flex flex-col w-full h-screen justify-center items-center  text-colored">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="w-20 h-20  animate-spin">
            <path stroke-linecap="round" stroke-linejoin="round"
                d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
        </svg>
        <h2>Caricamento in corso</h2>
    </div>

    <div *ngIf="!showDoc && error" class="flex flex-col w-full  h-screen justify-center items-center  text-red-600">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="w-20 h-20">
            <path stroke-linecap="round" stroke-linejoin="round"
                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
        </svg>

        <h2>Link non valido</h2>
    </div>

</div>